// extracted by mini-css-extract-plugin
export var orderDetails = "_qq-2";
export var orderImage = "_qq-1";
export var orderMeta = "_qq-3";
export var orderSummary = "_qq-0";
export var rightArrow = "_qq-4";